/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ConnectorAndActiveTransactionInfo } from "./ConnectorAndActiveTransactionInfo";
import {
    ConnectorAndActiveTransactionInfoFromJSON,
    ConnectorAndActiveTransactionInfoFromJSONTyped,
    ConnectorAndActiveTransactionInfoToJSON,
} from "./ConnectorAndActiveTransactionInfo";

/**
 *
 * @export
 * @interface DeviceActiveTransactionsResponse
 */
export interface DeviceActiveTransactionsResponse {
    /**
     *
     * @type {string}
     * @memberof DeviceActiveTransactionsResponse
     */
    deviceIdentity?: string;
    /**
     * Every connector on the charger
     * @type {Array<ConnectorAndActiveTransactionInfo>}
     * @memberof DeviceActiveTransactionsResponse
     */
    connectors?: Array<ConnectorAndActiveTransactionInfo>;
}

/**
 * Check if a given object implements the DeviceActiveTransactionsResponse interface.
 */
export function instanceOfDeviceActiveTransactionsResponse(
    value: object,
): value is DeviceActiveTransactionsResponse {
    return true;
}

export function DeviceActiveTransactionsResponseFromJSON(
    json: any,
): DeviceActiveTransactionsResponse {
    return DeviceActiveTransactionsResponseFromJSONTyped(json, false);
}

export function DeviceActiveTransactionsResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceActiveTransactionsResponse {
    if (json == null) {
        return json;
    }
    return {
        deviceIdentity:
            json["deviceIdentity"] == null ? undefined : json["deviceIdentity"],
        connectors:
            json["connectors"] == null
                ? undefined
                : (json["connectors"] as Array<any>).map(
                      ConnectorAndActiveTransactionInfoFromJSON,
                  ),
    };
}

export function DeviceActiveTransactionsResponseToJSON(
    value?: DeviceActiveTransactionsResponse | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        deviceIdentity: value["deviceIdentity"],
        connectors:
            value["connectors"] == null
                ? undefined
                : (value["connectors"] as Array<any>).map(
                      ConnectorAndActiveTransactionInfoToJSON,
                  ),
    };
}
